<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <div class="">
      <div class="mr-3 mx-1 rounded content_warranty" >
        <div class="ma-10">
          <v-row class="py-10">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  v-model="renewDetail.name"
                  label="Tên khách hàng"
                  placeholder="Nhập tên khách hàng"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  v-model="renewDetail.phone"
                  label="Số điện thoại"
                  placeholder="Số điện thoại"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  v-model="renewDetail.province_name"
                  placeholder="Nhập địa chỉ"
                  label="Địa chỉ"
                  readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  v-model="renewDetail.product_sku"
                  label="Mã sản phẩm"
                  placeholder="Nhập mã sản phẩm"
                  readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="4">
                  <v-text-field
                      background-color="#EDF2F7"
                      filled
                      v-model="date"
                      label="Thời gian"
                      readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select
                      filled
                      class="width-input"
                      background-color="#EDF2F7"
                      v-model="renewDetail.status"
                      :items="active"
                      item-text="name"
                      item-value="id"
                      label="Chọn trạng thái"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>

<!--            <v-col cols="12">-->
<!--              <v-textarea-->
<!--                  filled-->
<!--                  :text="advicesDetail.note"-->
<!--                  v-model="advicesDetail.note"-->
<!--                  label="Ghi chú"-->
<!--                  placeholder="Nhập ghi chú"-->
<!--                  background-color="#EDF2F7"-->
<!--              >-->
<!--              </v-textarea>-->
<!--            </v-col>-->

          </v-row>
        </div>
      </div>
      <div style="width: 60%">
        <div class="justify-center text-center my-5 border_bottom ">
          <v-btn color="primary" width="180" @click="update_renew">
            Lưu
          </v-btn>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import {GET_DETAIL_RENEW, UPDATE_RENEW} from "@/store/modules/renew";
import {mapGetters} from "vuex";


export default {
  name: "Edit_renew",
  data(){
    return{
      page: "Chỉnh sửa thu cũ đổi mới",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Thu cũ đổi mới",
          disabled: true,
        },
        {
          text: "Chỉnh sửa thu cũ đổi mới",
          disabled: true,
        },
      ],
      active: [
        {id:1, name:'CHƯA TƯ VẤN'},
        {id:2, name:'ĐANG TƯ VẤN'},
        {id:3, name:'ĐÃ TƯ VẤN'},
        {id:4, name:'BỎ QUA'},
      ],
date:''
    }
  },
  computed: {
    ...mapGetters({
      renewDetail: "renewDetail",
    }),
  },

  async created() {
    await this.$store.dispatch(`${GET_DETAIL_RENEW}`, this.$route.params.id);
    this.date = this.formatDate(this.renewDetail.created_at)

  },

  methods:{
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    update_renew(){
      this.$store.dispatch(`${UPDATE_RENEW}`, this.renewDetail).then((data) => {
        if (data) {
          if(data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$router.go(-1);
          }
          else {
            alert(data.data.error)
          }
        }
      });
    }
  }
}
</script>

<style scoped >
.content_warranty {
  width: 60%;
  background: #ffffff;
  min-height: 600px;
}
</style>